export default {
    service: state => state.services
}